import { createAction } from 'typesafe-actions';

import { IdleMonitorActions, IdleMonitorKeys } from '../constants/IdleMonitor';

type UpdateParams = $TSFixMe;

interface UpdatePayload {
  [IdleMonitorKeys.IDLE_STATUS]: UpdateParams;
}

export const updateIdleMonitor = createAction(
  IdleMonitorActions.UPDATE,
  (idleStatus: UpdateParams) => ({ [IdleMonitorKeys.IDLE_STATUS]: idleStatus }),
)<UpdatePayload>();
export type UpdateAction = ReturnType<typeof updateIdleMonitor>;

export const startIdleMonitor = createAction(IdleMonitorActions.START)();
export type StartAction = ReturnType<typeof startIdleMonitor>;
